import { ReactNode } from "react";
import { createPortal } from "react-dom";
type PortalProps = {
  children: ReactNode;
  portalId?: string;
};
const RavenPortalComponent = ({ children}: PortalProps) => {
  const portalRoot = document.getElementById( "portal-root");
  return portalRoot ? createPortal(children, portalRoot) : null;
};
export default RavenPortalComponent;






